import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/gift-accounting")({
  component: lazyRouteComponent(() => import("./-pages/admin.gift-accounting")),
  head: () => ({
    meta: [
      { title: "محاسبة الهدايا — Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
